import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter005() {
  return <KbChapterPage slug="chapter-005" />;
}

(Chapter005 as unknown as { path: string }).path = "/theory-album/005";
